module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container_wrap",
    on: {
      "click": _vm.toDetail
    }
  }, [(_vm.row && _vm.row.pics && _vm.row.pics.length > 0 && false) ? _c('div', {
    staticClass: "left_img"
  }, [(_vm.tag == '推荐') ? _c('div', {
    staticClass: "img_flag img_flag_recommond"
  }, [_vm._v("\n        推荐\n      ")]) : (_vm.tag == '最新') ? _c('div', {
    staticClass: "img_flag img_flag_new"
  }, [_vm._v("\n        最新\n      ")]) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.row && _vm.row.pics && _vm.row.pics[0].url ?
        _vm.row.pics[0].url :
        '#',
      "alt": "新闻图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "right_content"
  }, [_c('div', {
    staticClass: "right_content_title",
    style: (_vm.tag == '推荐' ? 'color:#1981FF' : '')
  }, [_vm._v("\n        " + _vm._s(_vm.row.title) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "right_content_operations"
  }, [_c('div', {
    staticClass: "operations_common operations_date"
  }, [_c('div', {
    staticClass: "operations_common_num"
  }, [_vm._v("\n            " + _vm._s(_vm._f("yearForm")(_vm.row.create_time)) + "-" + _vm._s(_vm._f("monthForm")(_vm.row.create_time)) + "-" + _vm._s(_vm._f("dayForm")(_vm.row.create_time)) + "\n\n                " + _vm._s(_vm.row.views_count) + "阅读\n          ")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20d82808","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mainindex/NewsItem.vue
// module id = 1405
// module chunks = 0